/**
 * The main component that renders single TabComponent
 * instances.
 */

import {
    Component,
    ContentChildren,
    QueryList,
    AfterContentInit,
    ViewChild,
    ComponentFactoryResolver,
    ViewContainerRef
  } from '@angular/core';
  
  import { TabComponent } from './tab.component';
  import { DynamicTabsDirective } from './dynamic-tabs.directive';
  
  @Component({
    selector: 'my-tabs',
    template: `
      <ul class="nav nav-tabs">
        <li class="new-tabs" *ngFor="let tab of tabs" (click)="selectTab(tab)" [class.active]="tab.active">
          <span style="cursor: pointer;">{{tab.title}}</span>
        </li>
        <!-- dynamic tabs -->
        <li class="dynamic-new-tabs"  *ngFor="let tab of dynamicTabs" (click)="selectTab(tab)" [class.active]="tab.active">
          <span>{{tab.dataContext.TabTitle}} <span *ngIf="tab.isCloseable" (click)="closeTab(tab)"><i class="mdi mdi-close-box" style="cursor: pointer;"></i></span></span>
        </li>
        <span class="tab-close" *ngIf="dynamicTabs.length > 0" (click)="closeAll()">close all</span>
      </ul>
      <ng-content></ng-content>
      <ng-template dynamic-tabs #container></ng-template>
    `,
    styles: [
      `
      .tab-close {
        height: 23px;
        color: #fff;
        /* font-weight: 700; */
        margin-left: 10px;
        margin-bottom: 5px;
        cursor: pointer;
        background: #188bf8;
        font-size: 12px;
        padding: 2px;
        padding-left: 5px;
        padding-right: 5px;
        border-radius: 2px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        border-width: 1px;
        border-style: solid;
        font-size: 11px;
        line-height: 1.4285714286;
        font-family: inherit;
        text-align: center;
        text-decoration: none;
        white-space: nowrap;
        display: -ms-inline-flexbox;
        display: -webkit-inline-box;
        display: inline-flex;
        -ms-flex-align: center;
        -webkit-box-align: center;
        align-items: center;
        -ms-flex-pack: center;
        -webkit-box-pack: center;
        justify-content: center;
        vertical-align: middle;
        -webkit-user-select: none;
        -ms-user-select: none;
        -moz-user-select: none;
        user-select: none;
        cursor: pointer;
        outline: none;
        -webkit-appearance: none;
        position: relative;
        border: none;
        -webkit-box-shadow: 1px 2px 9px 0px #cacbcc;
        box-shadow: 1px 2px 9px 0px #cacbcc;
        border-radius: 4px;
      }
      .new-tabs
      {
        height: 23px;
        color: #fff;
        /* font-weight: 700; */
        margin-left: 10px;
        margin-bottom: 5px;
        cursor: pointer;
        background: #188bf8;
        font-size: 12px;
        padding: 2px;
        padding-left: 5px;
        padding-right: 5px;
        border-radius: 2px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        border-width: 1px;
        border-style: solid;
        font-size: 11px;
        line-height: 1.4285714286;
        font-family: inherit;
        text-align: center;
        text-decoration: none;
        white-space: nowrap;
        display: -ms-inline-flexbox;
        display: -webkit-inline-box;
        display: inline-flex;
        -ms-flex-align: center;
        -webkit-box-align: center;
        align-items: center;
        -ms-flex-pack: center;
        -webkit-box-pack: center;
        justify-content: center;
        vertical-align: middle;
        -webkit-user-select: none;
        -ms-user-select: none;
        -moz-user-select: none;
        user-select: none;
        cursor: pointer;
        outline: none;
        -webkit-appearance: none;
        position: relative;
        border: none;
        -webkit-box-shadow: 1px 2px 9px 0px #cacbcc;
        box-shadow: 1px 2px 9px 0px #cacbcc;
        border-radius: 4px;
      }
      .dynamic-new-tabs
      {
        height: 23px;
        color: #163e70;
        font-weight: 700;
        border: 1px solid #efeded;
        margin-left: 10px;
        padding-left: 5px;
        padding-right: 5px;
        height: 23px;
        border-radius: 3px;
        cursor: pointer;
        box-shadow: 1px 1px 0px 0px #9ea8b3;
        color: #daffff;
    /* font-weight: 700; */
    margin-left: 10px;
    margin-bottom: 5px;
    cursor: pointer;
    background: #188bf8;
    font-size: 12px;
    padding: 2px;
    padding-left: 5px;
    padding-right: 5px;
    border-radius: 2px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    border-width: 1px;
    border-style: solid;
    font-size: 11px;
    line-height: 1.4285714286;
    font-family: inherit;
    text-align: center;
    text-decoration: none;
    white-space: nowrap;
    display: -ms-inline-flexbox;
    display: -webkit-inline-box;
    display: inline-flex;
    -ms-flex-align: center;
    -webkit-box-align: center;
    align-items: center;
    -ms-flex-pack: center;
    -webkit-box-pack: center;
    justify-content: center;
    vertical-align: middle;
    -webkit-user-select: none;
    -ms-user-select: none;
    -moz-user-select: none;
    user-select: none;
    cursor: pointer;
    outline: none;
    -webkit-appearance: none;
    position: relative;
    border: none;
    -webkit-box-shadow: 1px 2px 9px 0px #cacbcc;
    box-shadow: 1px 2px 9px 0px #cacbcc;
    border-radius: 4px;
    
      }
      .nav-tabs {
        border-bottom: 1px solid #a6b7bf;
        margin-top: 10px;
    }
      `
    ]
  })
  export class TabsComponent implements AfterContentInit {
    dynamicTabs: TabComponent[] = [];
  
    @ContentChildren(TabComponent) tabs: QueryList<TabComponent>;
  
    @ViewChild(DynamicTabsDirective, { static: false }) dynamicTabPlaceholder: DynamicTabsDirective;
    /*
      Alternative approach of using an anchor directive
      would be to simply get hold of a template variable
      as follows
    */
    // @ViewChild('container', {read: ViewContainerRef}) dynamicTabPlaceholder;
  
    constructor(private _componentFactoryResolver: ComponentFactoryResolver) {}
  
    // contentChildren are set
    ngAfterContentInit() {
      // get all active tabs
      const activeTabs = this.tabs.filter(tab => tab.active);
      // if there is no active tab set, activate the first
      if (activeTabs.length === 0) {
        this.selectTab(this.tabs.first);
      }
    }
  
    openTab(title: string, template, data, isCloseable = false) {
      // get a component factory for our TabComponent
      const componentFactory = this._componentFactoryResolver.resolveComponentFactory(
        TabComponent
      );
  
      //check if tab already exist then open it
      var found = false;
      this.dynamicTabs.forEach((value,index) => {
        if(value.dataContext.TabTitle  == title){
          this.selectTab(this.dynamicTabs[index]);
          found = true;
        }
      });
 
      if(found){return;}
      // fetch the view container reference from our anchor directive
      const viewContainerRef = this.dynamicTabPlaceholder.viewContainer;
  
      // alternatively...
      // let viewContainerRef = this.dynamicTabPlaceholder;
  
      // create a component instance
      const componentRef = viewContainerRef.createComponent(componentFactory);
  
      // set the according properties on our component instance
      const instance: TabComponent = componentRef.instance as TabComponent;
      
      instance.template = template;
      instance.dataContext = data;
      instance.dataContext.TabTitle = title;
      instance.title =  instance.dataContext.TabTitle;
      instance.isCloseable = isCloseable;
      // remember the dynamic component for rendering the
      // tab navigation headers
      this.dynamicTabs.push(componentRef.instance as TabComponent);
  
      // set it active
      this.selectTab(this.dynamicTabs[this.dynamicTabs.length - 1]);
    }
  
    selectTab(tab: TabComponent) {
      // deactivate all tabs
      this.tabs.toArray().forEach(tab => (tab.active = false));
      this.dynamicTabs.forEach(tab => (tab.active = false));
      // activate the tab the user has clicked on.
      tab.active = true;
    }

    //note there is no template being used yet here.
    //we assume that the template exist in html first
    selectTabByTitle(title){
      this.tabs.toArray().forEach((item) => {
        if(item.title == title){
          this.selectTab(item);
          return;
        };
      })
    }
  
    closeTab(tab: TabComponent) {
      for (let i = 0; i < this.dynamicTabs.length; i++) {
        if (this.dynamicTabs[i] === tab) {
          // remove the tab from our array
          this.dynamicTabs.splice(i, 1);
  
          // destroy our dynamically created component again
          let viewContainerRef = this.dynamicTabPlaceholder.viewContainer;
          // let viewContainerRef = this.dynamicTabPlaceholder;
          viewContainerRef.remove(i);
  
          // set tab index to 1st one
          this.selectTab(this.tabs.first);
          break;
        }
      }
    }
  
    closeActiveTab() {
      const activeTabs = this.dynamicTabs.filter(tab => tab.active);
      if (activeTabs.length > 0) {
        // close the 1st active tab (should only be one at a time)
        this.closeTab(activeTabs[0]);
      }
    }

    closeAll(){
      var tabLength = Number(this.dynamicTabs.length);
      for (let i = 0; i <= tabLength; i++) {
          // remove the tab from our array
          this.dynamicTabs.splice(i, 1);
          // destroy our dynamically created component again
          let viewContainerRef = this.dynamicTabPlaceholder.viewContainer;
          // let viewContainerRef = this.dynamicTabPlaceholder;
          viewContainerRef.remove(i);
      }
      this.dynamicTabs = [];
      this.tabs.toArray().forEach(tab => (tab.active = false));
      this.selectTab(this.tabs.first);
    }
  }
  